<template>
  <t-space direction="horizontal" style="height: 80vh;" size="small">
    <t-space></t-space>
      <!--拖拽菜单栏-->
    <t-space direction="vertical">
      <t-card 
              title="操作版"
              style="width: 20vw; height: 90vh; top: 1vh;">
        <t-space direction="vertical">
          <h1>元件</h1>
          <t-space>
            <t-tooltip content="文本">
              <div class="ep-draggable-item item" tid="defaultModule.text">
                <t-icon name="letters-t"  size="large"/>
              </div>
            </t-tooltip>

            <t-tooltip content="长文本">
              <div class="ep-draggable-item item" tid="defaultModule.longText">
                <t-icon name="letters-l"  size="large"/>
              </div>
            </t-tooltip>

            <t-tooltip content="表格">
              <div class="ep-draggable-item item" tid="defaultModule.emptyTable">
                <t-icon name="table"  size="large"/>
              </div>
            </t-tooltip>

            <t-tooltip content="HTML">
              <div class="ep-draggable-item item" tid="defaultModule.html">
                  <t-icon name="code"  size="large"/>
              </div>
            </t-tooltip>

            <t-tooltip content="默认单据">
              <div class="ep-draggable-item item" tid="tableProviderModule.table">
                  <t-icon name="ticket"  size="large"/>
              </div>
            </t-tooltip>
          </t-space>
          <h1>其他操作</h1>
          <t-space direction=" horizontal">
            <t-button @click="()=>{printContentDialog = true}">保存模版</t-button>
            <t-button @click="()=>{ visibleModelessDrag = true} ">显示设置</t-button>
            <t-button @click="()=>{ showHelp = true} ">数据说明</t-button>
          </t-space>

        </t-space>
      </t-card>
      <t-space></t-space>
    </t-space>
    <!--设计画板-->
    <t-space>
      <!-- <t-space></t-space> -->
      <t-card
        title="画板"
        style="top: 1vh; width: 64.5vw; height: 90vh; ">
        <div id="hiprint-printTemplate" class="hiprint-printTemplate"></div>
      </t-card>
    </t-space>
    <!--元件属性配置-->
    <t-dialog
      :visible="visibleModelessDrag"
      header="点击元件进行设置"
      mode="modeless"
      draggable
      :placement="'right'"
      :cancelBtn="null"
      :confirmBtn="null"
      :on-close="() => (visibleModelessDrag = false)"
    >
    <template #body>
      <div id="PrintElementOptionSetting" class="PrintElementOptionSetting"></div>
    </template>
  </t-dialog>
  <t-dialog 
      :visible="showHelp"
      header="数据说明"
      mode="modeless"
      draggable
      width="60vw"
      :on-close="() => (showHelp = false)"
      :cancelBtn="null"
      :confirmBtn="null">
            <t-space direction=" horizontal">
              <t-descriptions bordered :column="1">
                <t-descriptions-item label="写在最前">
                  <p>此处说明的数据将会影响打印时数据填充，一般在组件的设置中，填写对应的字段名即可。</p>
                  <p>在表格中的数据，则需要在“列”的字段名中设置，在填写字段名后写入“#”后填入对应字段名即可</p>
                </t-descriptions-item>
                <t-descriptions-item label="transactor">对应单据中所填写的“经办人”</t-descriptions-item>
                <t-descriptions-item label="data">对应单据所创建的“日期”</t-descriptions-item>
                <t-descriptions-item label="bill_of_document_id">对应单据创立时的“单据编号”</t-descriptions-item>
                <t-descriptions-item label="table">
                      table(表格对应的字段名)中包含:
                      <p>index(行号)</p> 
                      <p>name(商品名称)</p>
                      <p>model(规格)</p>
                      <p>amount(数量)</p>
                      <p>price(单价)</p>
                      <p>total_price(总价) = amount * price </p>     
                      <p>discost(折扣)</p>
                      <p>discost_price(折后价格) = amount * price * (discost / 100) </p>
                </t-descriptions-item>
                <t-descriptions-item label="end_price">table中的discost_price的总和,若无则为total_price的总和</t-descriptions-item>
              </t-descriptions>
            </t-space>
  </t-dialog>
  <t-dialog
      v-model:visible="printContentDialog"
      theme="info"
      header="模版命名"
      body="对话框内容"
      :on-close="()=>{ printContentDialog = false}"
      @confirm="Save"
    >
    <t-space direction="vertical" style="width: 100%;">
      <t-input v-model="printContent" :maxlength="15" placeholder="请输入模版名称"></t-input>
      <t-typography-text disabled>请保持模版名不重复，方便使用时选择。</t-typography-text>
    </t-space>
  </t-dialog>

  </t-space>
</template>

<script setup>
import { onMounted,ref } from "vue";
import { hiprint,defaultElementTypeProvider } from "vue-plugin-hiprint";
import $ from 'jquery'; 
import { NotifyPlugin } from 'tdesign-vue-next';
import request from "@/request/request";
import { TableProvider } from "./tableProvider";

const showHelp = ref(false)
const printContent = ref("")
const printContentDialog = ref(false);
const visibleModelessDrag = ref(false);
// // 注册默认面板
hiprint.init({
    providers: [defaultElementTypeProvider(),TableProvider()],
});
// // 必须在 dom 加载完成之后给刚刚绑定上的元素添加上拖拽事件
let hiprintTemplate = ref()
const buildDesigner = () => {
  // 绑定拖拽事件
  hiprint.PrintElementTypeManager.buildByHtml($(".ep-draggable-item"));
  // new hiprint.PrintTemplate 的返回值是一个模板的实例
  // 传入的参数各种的配置项
  // settingContainer：属性栏面板
  hiprintTemplate.value = new hiprint.PrintTemplate({
    settingContainer: "#PrintElementOptionSetting",
    template: {
      panels: [{
        width: 300,
        height: 200
      }]
    }
  });
  // 构建一个设计模板，指定容器，是否开启网格展示
  hiprintTemplate.value.design("#hiprint-printTemplate",{grid: true});
};

const Save = ()=>{
  let templateJson =  JSON.stringify(hiprintTemplate.value.getJson())
  request.UploadPrintTemplate(templateJson,printContent.value,(res)=>{
      if(res.data.success) {
        NotifyPlugin.success({
          title: "上传成功",
          content: '模板上传成功.',
          duration: 3000
        })
      }else {
        NotifyPlugin.error({
          title: '打印模板上传失败',
          content: '打印模板上传失败。' + res.data.tag,
          duration: 3000,
        })
      }
      printContentDialog.value = false
  },
  (err)=>{
    NotifyPlugin.error({
      title: "请求失败",
      content: '模板上传失败.' + err,
      duration: 3000
    })
  })
}

onMounted(() => {
  buildDesigner();
});
// /**
//  * 浏览器打印
//  */
// const print = () => {
//   // 打印数据，key 对应 元素的 字段名
//   let printData = { name: "CcSimple" };
//   // 参数: 打印时设置 左偏移量，上偏移量
//   let options = { leftOffset: -1, topOffset: -1 };
//   // 扩展
//   let ext = {
//     callback: () => {
//       console.log("浏览器打印窗口已打开");
//     },
//     styleHandler: () => {
//       // 重写 文本 打印样式
//       return "<style>.hiprint-printElement-text{color:red !important;}</style>";
//     },
//   };
//   // 调用浏览器打印
//   hiprintTemplate.print(printData, options, ext);
// };
// /**
//  * 直接打印: 借助客户端,静默打印(无弹窗直接打印)
//  * 注意: 需要先连接客户端
//  */
// const print2 = () => {
//   if (hiprint.hiwebSocket.opened) {
//     hiprintTemplate.print2({});
//   } else {
//     alert("请先连接客户端(刷新网页), 然后再点击「直接打印」");
//   }
// };
</script>

<style>

</style>